// extracted by mini-css-extract-plugin
export var iconClose = "NavBar-module--iconClose--48587";
export var iconMenu = "NavBar-module--iconMenu--46100";
export var iconSwap = "NavBar-module--iconSwap--d28b6";
export var isOpen = "NavBar-module--isOpen--51475";
export var menuModalCtaButton = "NavBar-module--menuModalCtaButton--e45e4";
export var menuModalCtaButtonPrimary = "NavBar-module--menuModalCtaButtonPrimary--57a96";
export var menuModalCtaButtonSecondary = "NavBar-module--menuModalCtaButtonSecondary--26390";
export var menuModalCtaItem = "NavBar-module--menuModalCtaItem--c94bb";
export var menuModalCtaList = "NavBar-module--menuModalCtaList--aa8c7";
export var navBar_ctaList = "NavBar-module--navBar_ctaList--6dba3";
export var navBar_detailLink = "NavBar-module--navBar_detailLink--c6217";
export var navBar_detailList = "NavBar-module--navBar_detailList--bb5d9";
export var navBar_detailMain = "NavBar-module--navBar_detailMain--fb03a";
export var navBar_detailMainIa = "NavBar-module--navBar_detailMainIa--3ac85";
export var navBar_icon = "NavBar-module--navBar_icon--0c60a";
export var navBar_iconIa = "NavBar-module--navBar_iconIa--cac7a";
export var navBar_langSwitcherItem = "NavBar-module--navBar_langSwitcherItem--72df9";
export var navBar_rootItem = "NavBar-module--navBar_rootItem--9fb4c";
export var navBar_rootList = "NavBar-module--navBar_rootList--f7470";
export var navBar_solutionsColumn = "NavBar-module--navBar_solutionsColumn--f997b";
export var navBar_solutionsColumnRight = "NavBar-module--navBar_solutionsColumnRight--94144";
export var navBar_solutionsGrid = "NavBar-module--navBar_solutionsGrid--c1f66";
export var navBar_solutionsLink = "NavBar-module--navBar_solutionsLink--a24d1";
export var navBar_solutionsList = "NavBar-module--navBar_solutionsList--858c8";
export var navBar_solutionsNeedIcon = "NavBar-module--navBar_solutionsNeedIcon--8e831";
export var navBar_solutionsPanel = "NavBar-module--navBar_solutionsPanel--74941";
export var navBar_solutionsPill = "NavBar-module--navBar_solutionsPill--3be19";
export var navBar_solutionsPillIcon = "NavBar-module--navBar_solutionsPillIcon--671cb";
export var navBar_solutionsPillList = "NavBar-module--navBar_solutionsPillList--1a93f";
export var navBar_solutionsRightLink = "NavBar-module--navBar_solutionsRightLink--0ae83";
export var navBar_solutionsRightList = "NavBar-module--navBar_solutionsRightList--73519";
export var navBar_solutionsTitle = "NavBar-module--navBar_solutionsTitle--c6a44";
export var navBar_title = "NavBar-module--navBar_title--04335";
export var navBar_titleIa = "NavBar-module--navBar_titleIa--8dc76";
export var navbar = "NavBar-module--navbar--c3801";
export var navbar_container = "NavBar-module--navbar_container--547e2";
export var navbar_logo = "NavBar-module--navbar_logo--b2c6c";
export var navbar_logoLink = "NavBar-module--navbar_logoLink--12018";
export var navbar_menu = "NavBar-module--navbar_menu--e0d7b";